import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../Header';
import Copyright from '../Copyright';
import Routes from '../Routes';
import './style.css';
import ContactTable from '../ContactTable';

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      innerWidth: null,
    };
    this.getInnerWidth = this.getInnerWidth.bind(this);
  }

  getInnerWidth() {
    this.setState(() => ({ innerWidth: window.innerWidth }));
  }

  componentDidMount() {
    this.getInnerWidth();
    window.addEventListener('resize', this.getInnerWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getInnerWidth);
  }

  render() {
    const { innerWidth } = this.state;
    const { location } = this.props;
    const flexDirection =
      innerWidth >= 770 ? 'flex-row' : 'flex-column-reverse';
    const alignItems = innerWidth >= 770 ? 'start' : 'center';
    const textSize = innerWidth < 515 ? 'small' : '';

    return (
      <div className='App'>
        <Header />
        <Routes innerWidth={innerWidth} />
        {location.pathname !== '/contact' && (
          <section
            className={`d-flex justify-content-around align-items-${alignItems} ${flexDirection} ${textSize} p-3 bg-white`}>
            <div className='mt-2'>
              <ContactTable />
            </div>
          </section>
        )}
        <Copyright />
      </div>
    );
  }
}

export default withRouter(App);
